var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BaseAccount"},[_c('pre',{domProps:{"textContent":_vm._s(_vm.$attrs)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }